import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { personApi } from '../../services/personApi';
import { personKeys } from './useGetPerson';

export function useDeletePerson() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => personApi.deletePerson(id),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully deleted person');
        queryClient.invalidateQueries({ queryKey: personKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to delete person'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to delete person'}`);
    },
  });
}
